module.exports = __webpack_public_path__ + "static/media/subcategories-list-icon.d2e8ead7.svg";